

import { Component, Vue } from "vue-property-decorator"
import { namespace } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import { Severity } from "@/types"

import api from "@/services/api"
import apiSeverity from "@/services/api_Severity"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class SeveritySetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	@caseStore.Getter("getCases") public cases: any;
	@caseStore.Action public casesLoad!: () => void;
	@caseStore.Action public detailsLoad!: (refreshData: boolean) => void;

	private loading: boolean = false;
	private severities: Severity[] = [];

	private severityInUse: boolean = false;
	private severityReplacementListForDeletion: Severity[] = [];
	private replacementSeverity: any = null;

	public async mounted () {
		await this.loadSeverities()
	}

	private get columns (): any[] {
		return [
			{ key: "title", label: "Title", sortable: true, errors: (item: any) => (item.title !== "") ? null : "Please enter a title" },
			{ key: "level", label: "Level", sortable: true, dataType: "number", errors: (item: any) => (item.level > 0) ? null : "Please enter a level number" }
		]
	}

	private async loadSeverities () {
		this.loading = true
		this.severities = await apiSeverity.severityList()
		this.loading = false
	}

	private createSeverity () {
		return { id: null, title: "", level: 0 }
	}

	private async saveSeverity (severity: Severity) {
		const currentSeverity = this.severities.find(s => s.id === severity.id)

		// Add / update
		if (severity.id === null || (currentSeverity && currentSeverity.title !== severity.title)) {
			await apiSeverity.severitySave(severity)
		}

		this.loadSeverities()

		// Store
		this.loading = true
		const refreshData: boolean = true
		await this.detailsLoad(refreshData)
		this.loading = false
	}

	private async deleteSeverity (severity: Severity) {
		if (this.severities.length > 1) {
			this.loading = true

			if (this.replacementSeverity != null) {
				await api.replaceSeverityOnCaseList(severity.id, this.replacementSeverity.id)
			}

			await apiSeverity.severityDelete(severity)

			await this.loadSeverities()

			// Store
			this.loading = true
			const refreshData: boolean = true
			await this.detailsLoad(refreshData)
			this.loading = false
		}
	}

	public async canDeleteSeverity (severity: Severity): Promise<boolean> {
		this.replacementSeverity = null
		this.severityReplacementListForDeletion = []

		this.severityInUse = await api.isSeverityInUse(severity.id!)
		this.$refs.dataTable.$refs.dataModal.deleteConfirmButtonDisabled = this.severityInUse

		this.severityReplacementListForDeletion = this.severities.filter(s => s.id !== severity.id)
		return this.severities.length > 1
	}

	private onDeletionSeverityReplacementSelected () {
		this.$refs.dataTable.$refs.dataModal.deleteConfirmButtonDisabled = false
	}
}
